document.addEventListener("DOMContentLoaded", function () {
    function showMessage(message, type = "success") {
        let messageDiv = document.getElementById("wishlist-message");
        
        if (!messageDiv) {
            messageDiv = document.createElement("div");
            messageDiv.id = "wishlist-message";
            messageDiv.className = "wishlist-message";
            document.querySelector(".wishlist-page").insertBefore(messageDiv, document.getElementById("wishlist-container"));
        }

        messageDiv.innerHTML = message;
        messageDiv.className = `wishlist-message ${type}`;

        setTimeout(() => {
            messageDiv.innerHTML = "";
            messageDiv.className = "wishlist-message";
        }, 3000);
    }

    function addToWishlist(event) {
        event.preventDefault();
        let productHandle = event.target.getAttribute("data-product-handle");
        let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

        if (!wishlist.includes(productHandle)) {
            wishlist.push(productHandle);
            localStorage.setItem("wishlist", JSON.stringify(wishlist));
            showMessage("❤️ Product added to wishlist!", "success"); // No alert
        } else {
            showMessage("⚠️ Product is already in your wishlist!", "warning"); // No alert
        }

        updateWishlistCount();
    }

    function updateWishlistCount() {
        let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
        let countElement = document.querySelector(".wishlist-count");
        if (countElement) countElement.innerText = wishlist.length;
    }

    function setupWishlistButtons() {
        document.querySelectorAll(".wishlist-btn").forEach(button => {
            button.addEventListener("click", addToWishlist);
        });
    }

    updateWishlistCount();
    setupWishlistButtons();
});
